import NewAppointmentPage from "./NewAppointmentPage";

export default NewAppointmentPage;

export * from "./NewAppointmentPage";
